module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahand11-9d67fa911b0e66e6b38963a7eb681c58.jpg";